import { graphql, useStaticQuery } from 'gatsby';
import { useContext, useEffect, useMemo, useState } from 'react';
import GlobalContext from '../../../contexts/globalContext';
import { TabsEnum } from '../../../enums/enums';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import ModalOnbording from '../../molecules/modal-onbording/modal-onbording';
import './onbording.scss';

const ONBORDING = 'onbording';

const Onbording = () => {
    const [showOnbording, setShowOnbording] = useState(false);
    const [onboardinBusiness, setonboardinBusiness] = useState(false);
    const [indexOnboarding, setIndexOnboarding] = useState<number>(0);
    const contentData = useStaticQuery(graphql`
        query GET_PORTAL_ONBOARDING_DATA {
            allContentfulTemplate(
                filter: { titulo: { eq: "Onboarding  Portal" } }
            ) {
                nodes {
                    titulo
                    referencias {
                        ... on ContentfulTemplate {
                            nombre
                            imagen {
                                title
                                file {
                                    url
                                }
                            }
                            descripcion {
                                raw
                            }
                            referencias {
                                ... on ContentfulTemplate {
                                    copyBoton
                                    redireccion
                                }
                            }
                        }
                    }
                }
            }
        }
    `);
    const { localStorage } = useBrowserMode();
    const data = contentData.allContentfulTemplate.nodes[0].referencias;

    const onbordingContent = useMemo(() => {
        const OnbordingExtra = [
            {
                titleLocal: 'tabBussines',
                arrowDirection: 'left',
                position: 'o-onbording__tab-business',
                bkg: 'o-onbording__bkg-busines',
            },
            {
                titleLocal: 'loginBussines',
                arrowDirection: 'right',
                position: 'o-onbording__tab-login',
                bkg: 'o-onbording__bkg-login',
            },
        ];
        return data.map((item, index) => {
            return {
                ...item,
                index,
                ...OnbordingExtra[index],
            };
        });
    }, [data]);

    const [modalContent, setModalContent] = useState<any>();

    const { gigyaContext, business, selectedTab } = useContext(GlobalContext);

    useEffect(() => {
        const { gigyaAccount, isLoadingGigya } = gigyaContext;
        const keyLocal = `${ONBORDING}_${onbordingContent[0]?.titleLocal}`;
        const showlocalOnbording = localStorage?.getItem(keyLocal);
        const indicatorOnbording = parseInt(showlocalOnbording ?? '0');
        if (
            !isLoadingGigya &&
            gigyaAccount &&
            gigyaAccount?.data?.servicesAuth?.length &&
            indicatorOnbording < 2 &&
            selectedTab?.get === TabsEnum.PEOPLE
        ) {
            setonboardinBusiness(true);
            setTimeout(() => {
                setIndexOnboarding(0);
                setShowOnbording(true);
            }, 1000);
        }
    }, [gigyaContext?.gigyaAccount, gigyaContext?.isLoadingGigya]);

    useEffect(() => {
        const { gigyaAccount, isLoadingGigya } = gigyaContext;
        const options = gigyaContext.gigyaAccount?.data.servicesAuth ?? [];
        const keyLocal = `${ONBORDING}_${onbordingContent[1]?.titleLocal}`;
        const showlocalOnbording = localStorage?.getItem(keyLocal);
        const indicatorOnbording = parseInt(showlocalOnbording ?? '0');
        if (
            !isLoadingGigya &&
            gigyaAccount &&
            selectedTab?.get === TabsEnum.BUSINESS &&
            business?.get &&
            options?.length > 0 &&
            indicatorOnbording < 2
        ) {
            setonboardinBusiness(false);
            setTimeout(() => {
                setIndexOnboarding(1);
                setShowOnbording(true);
            }, 1000);
        }
    }, [
        gigyaContext?.gigyaAccount,
        gigyaContext?.isLoadingGigya,
        selectedTab?.get,
        business?.get,
    ]);

    useEffect(() => {
        setModalContent(onbordingContent[indexOnboarding]);
    }, [indexOnboarding]);

    const onClose = () => {
        setShowOnbording(false);
        const key_local = `${ONBORDING}_${modalContent?.titleLocal}`;
        const showlocalOnbording = localStorage?.getItem(key_local);
        const indicatorOnbording = parseInt(showlocalOnbording ?? '0');
        localStorage?.setItem(key_local, `${indicatorOnbording + 1}`);
    };

    if (!showOnbording) {
        return null;
    }

    return (
        <div className={'o-onbording'}>
            {modalContent && (
                <>
                    <div
                        className={`o-onbording__content ${modalContent?.position} ${
                            onboardinBusiness ? 'hide-mobile' : ''
                        }`}
                    >
                        <div
                            className={`o-onbording__content-arrow ${
                                modalContent?.arrowDirection ?? 'center'
                            }`}
                        />
                        <ModalOnbording
                            modalContent={modalContent}
                            onClose={onClose}
                        />
                    </div>
                    <div
                        className={`o-onbording__bkg ${modalContent?.bkg} ${
                            onboardinBusiness ? 'hide-mobile' : ''
                        }`}
                        onClick={() => onClose()}
                    />
                </>
            )}
        </div>
    );
};

export default Onbording;
